module.exports = __webpack_public_path__ + "img/poster.1a89b17e.png";